import { createORPCClient, type ClientContext } from "@orpc/client";
import { RPCLink, type RPCLinkOptions } from "@orpc/client/fetch";
import { createTanstackQueryUtils, type RouterUtils } from "@orpc/tanstack-query";
import type { RouterClient } from "@orpc/server";
import { createContext, useContext, useMemo, type PropsWithChildren } from "react";
import type { UserRouter } from "@corpuscomplete/core/orpc";

export namespace Rpc {
  export type Client = RouterUtils<RouterClient<UserRouter>>;

  const RpcContext = createContext<Client | null>(null);

  export function Provider({
    linkOptions,
    children,
  }: PropsWithChildren<{ linkOptions: RPCLinkOptions<ClientContext> }>) {
    const rpc = useMemo(() => {
      const link = new RPCLink(linkOptions);
      const client = createORPCClient<RouterClient<UserRouter>>(link);
      return createTanstackQueryUtils(client, { path: ["rpc"] });
    }, [linkOptions]);

    return <RpcContext.Provider value={rpc}>{children}</RpcContext.Provider>;
  }

  export function useRpc(): Client {
    const rpc = useContext(RpcContext);
    if (!rpc) {
      throw new Error("Rpc.useRpc() must be used within Rpc.Provider");
    }
    return rpc;
  }
}
